// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"104":"c060f858","227":"c060f858","267":"c060f858","465":"ae9d3ca5","564":"c060f858","673":"c060f858"}[chunkId] + ".css";
};